import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import { publicApi } from '../api/client';
import { Loader2, ArrowUpRight } from 'lucide-react';

const ToursPage = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.getTours().then((d) => { setTours(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <>
      <PageBanner
        title="Egypt Tour Categories"
        subtitle="Choose your Egypt journey style — Cairo & Nile combos, Red Sea escapes, desert oases and exclusive private-access tours."
        image="https://images.unsplash.com/photo-1600520611035-84157ad4084d?crop=entropy&cs=srgb&fm=jpg&q=85"
        crumbs={[{ label: 'Egypt Tours' }]}
      />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {loading ? (
            <div className="py-24 text-center"><Loader2 className="animate-spin inline text-[#304b71]" /></div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {tours.map((t, idx) => (
                <Link key={t.id} to="/packages" className={`group relative overflow-hidden rounded-2xl bg-black shadow-md hover:shadow-2xl transition-all duration-500 ${idx === 0 ? 'lg:col-span-2 aspect-[16/9] lg:aspect-auto lg:h-[380px]' : 'aspect-[4/3]'}`}>
                  <img src={t.image} alt={t.name} className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#304b71]/95 via-[#304b71]/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <div className="flex items-end justify-between mb-3">
                      <h3 className="font-serif text-2xl md:text-3xl leading-tight max-w-xs">{t.name}</h3>
                      <div className="w-12 h-12 rounded-full bg-white/15 border border-white/30 backdrop-blur flex items-center justify-center group-hover:bg-white group-hover:text-[#304b71] transition-colors"><ArrowUpRight size={18} /></div>
                    </div>
                    {t.description && <p className="text-white/85 text-sm max-w-md">{t.description}</p>}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ToursPage;
